
export default function InputBox(props) {
  const value = props.value;
  const name = props.name;
  const type = props.type;
  const label = props.label;
  const isRequired = props.isRequired;
  function onChangeText(value) {
    props.onChange(value);
  }
  return (
    <div className="col-md-6 text-left">
      <label className="custom-label">
        {label} {isRequired && <span className="astric">*</span>}
      </label>
      <input
        type={type}
        name={name}
        value={value}
        className="form-input"
        onChange={(e) => {
          onChangeText(e.target.value)
        }} />
    </div>
  );
}